import { ImportMappingSelector } from './ImportMappingSelector';
import { ImportRoutine } from '../ImportRoutine';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { StructureService } from '../../../services/structure_service';
import style from '../import_tool.less';
import { ImportMappingValues } from './ImportMappingValues';

interface ImportStepMappingProps extends React.ClassAttributes<any> {
    data: any;
    modul: string;
    onDataChange: (data: any) => void;
    onDone: () => void;
}

interface ImportStepMappingState {
    fields?: ReadonlyArray<any>;
    fieldData?: any;
    structure?: any;
    requiredFields: any;
    keyFields: any;
    selectedFields: any;
    selectedValues: any;
    checkedKeys: any;
    fehlendeFields: number;
    structureProblem: boolean;
    korrigieren: boolean;
    ubergenommen: boolean;
    changed: boolean;
    isReady: boolean;
}

export class ImportStepMapping extends React.Component<ImportStepMappingProps, ImportStepMappingState> {

    constructor(props: any) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyChange = this.onKeyChange.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.structureCheck = this.structureCheck.bind(this);
        console.log('Size of data-object-string:' + JSON.stringify(this.props.data).length);
        this.state = {
            requiredFields: {},
            keyFields: {},
            selectedFields: this.props.data.selectedFields ? this.props.data.selectedFields : {},
            selectedValues: this.props.data.selectedValues ? this.props.data.selectedValues : {},
            checkedKeys: this.props.data.checkedKeys ? this.props.data.checkedKeys : {},
            fehlendeFields: 0,
            structureProblem: false,
            korrigieren: false,
            ubergenommen: false,
            changed: false,
            isReady: false
        };
    }

    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(ImportRoutine) private importRoutine: ImportRoutine;

    componentDidMount() {
        const sheetName = this.props.data.sheetName;
        const headerRow = this.props.data.headerRow;
        const sheetData = this.props.data.sheetDataAll[sheetName];
        const fieldData = this.importRoutine.getFieldData(headerRow, sheetData);
        const fields = Object.keys(fieldData);
        const structure = this.structureService.getStructureByKey(this.props.modul, this.props.data.structureKey);
        const requiredFields = this.getRequiredFields((structure || {}).ATTS);
        const keyFields = this.getKeyFields((structure || {}).ATTS);
        this.setState({ fields, fieldData, structure, requiredFields, keyFields });
        this.structureCheck(fieldData, structure, headerRow, fields);
    }

    structureCheck(fieldData: Array<any>, structure: any, headerRow: Array<any>, fields: Array<any>) {
        const structureFields: Array<any> = structure.ATTS;
        let fehlendeFields: number = this.state.fehlendeFields;
        const undefinedFields: Array<any> = [];
        let undefinedMatch: any = '';

        for ( let i = 0; i < fieldData.length; i++) {
            undefinedMatch = !fieldData[i] || fieldData[i].match(/undefined/gi);
            if (undefinedMatch && undefinedMatch.length === headerRow.length) {
                undefinedFields.push(i);
            }
        }
        for ( let j = 0; j < undefinedFields.length; j++) {
            fields.splice(undefinedFields[j], 1);
        }

        if (Object.keys(this.state.selectedFields).length !== 0) {
            structureFields.forEach((k) => {
                if (fieldData.indexOf(k.NAME) === -1) {
                    fehlendeFields++;
                }
            });
            this.setState({ isReady: this.hasAllKeys(this.state.selectedFields || {}) });
        }
        // INFO Deaktiviert da nicht benötigt, fehlende Felder sind erstmal kein Fehler
        // if (fehlendeFields > 0) {
        //     this.setState({ fehlendeFields, structureProblem: true });
        // }
    }

    onValueChange(target: string, value: string) {
        const selectedValues: any = this.state.selectedValues || {};
        if (value === 'UNUSED') {
            selectedValues[target] = undefined;
        } else {
            selectedValues[target] = value;
        }
        this.setState({ selectedValues });
    }

    onChange(field: string, target: string) {
        const selectedFields = this.state.selectedFields;
        // const selectedFields = this.state.structureProblem && !this.state.changed ? this.newSelectedFields() : this.state.selectedFields;
        if (target === 'UNUSED') {
            selectedFields[field] = undefined;
        } else {
            selectedFields[field] = target;
        }
        this.setState({ selectedFields, isReady: this.hasAllKeys(selectedFields)});
    }

    onKeyChange(field: string, checked: boolean) {
        const checkedKeys = this.state.checkedKeys;
        checkedKeys[field] = checked;
        this.setState({ checkedKeys });
    }

    render() {
        if (!this.state.fields || !this.state.structure) {
            return (
                <div>
                    Ermittle Felder ...
                </div>
            );
        }
        const butDisabled = !this.hasSelectedField() || this.state.structureProblem || !this.state.isReady;
        // console.log('Disabled: ', butDisabled , this.hasSelectedField() , this.state.structureProblem , this.state.isReady);
        return (
            <div className={style.infobox}>
                <input
                    style={{
                        padding: 10, backgroundColor: butDisabled ? '#aaa' : '#afa', border: '2px solid #0a0', borderRadius: 5,
                        color: '#080', fontWeight: 'bold', width: 420, cursor: 'pointer'
                    }}
                    disabled={butDisabled}
                    type='button'
                    value='Mapping und Schlüsselauswahl übernehmen'
                    onClick={() => this.onFinish()}
                />
                {!this.state.isReady &&
                    this.renderHinweis()
                }
                {/*this.state.structureProblem &&
                    <div className={style.infobox}>
                        <div style={{ color: '#a00' }}>
                            Es gibt {this.state.fehlendeFields} Kopfzeile, was passen nicht für Structure!
                        </div>
                        <div>
                            <input
                                type='button'
                                value='Korrigieren'
                                onClick={() => this.setCorrect()}
                            />
                            <input
                                type='button'
                                value='Übernehmen'
                                onClick={() => this.setState({ structureProblem: false, ubergenommen: true })}
                            />
                        </div>
                    </div>
                */}
                <div>
                    <div className={style.rowContainer} style={{ fontWeight: 'bold', paddingTop: '1em' }}>
                        <div className={style.w200} style={{ margin: 5 }}>
                            Importierte Spalten:
                        </div>
                        <div className={style.w300} style={{ margin: 5 }}>
                            Zuordnung:
                        </div>
                    </div>
                </div>
                {this.getMappingValues()}
                {this.getMappings()}
            </div>
        );
    }

    renderHinweis() {
        const fields: Array<string> = [];
        Object.keys(this.state.keyFields || {})
            .forEach((field: string) => {
                if (Object.values(this.state.selectedFields || {}).indexOf(field) === -1) {
                    fields.push(this.state.keyFields[field]);
                }
            });
        if (fields.length === 0){
            return <div />;
        }
        return (
            <div style={{ color: '#a00', paddingTop: '1em' }}>
                <b>Bitte ordnen Sie, soweit möglich, die importierten Spalten den im Tool vorhandenen Erfassungsfeldern zu.</b>
                <br />
                <b>Folgende Schlüsselfelder müssen mindestens Zugeordnet werden:</b>
                <br />
                {fields.join(', ')}
            </div>
        );
    }

    private getRequiredFields(atts: Array<any>) {
        const fields: any = {};
        (atts || []).filter((att: any) => this.isRequired(att))
            .forEach((item: any) => fields[item.KEY] = item.NAME);
        return fields;
    }

    private getKeyFields(atts: Array<any>) {
        const fields: any = {};
        (atts || []).filter((att: any) => this.isKey(att))
            .forEach((item: any) => fields[item.KEY] = item.NAME);
        return fields;
    }

    private getMappings() {
        // console.log(this.state.fieldData); // fieldData = Feldnamen
        // console.log(this.state.fields); // fields = Feld-Keys
        console.log('Fd', this.state.fieldData);
        console.log('SEL', this.state.selectedFields);
        return this.state.fields.map((f, idx) =>
            <div key={`mapping_sel_${idx}`}>
                <ImportMappingSelector
                    name={this.state.fieldData[f]}
                    onChange={this.onChange}
                    onKeyChange={this.onKeyChange}
                    keyChecked={this.state.checkedKeys[this.state.fieldData[f]]
                        ? this.state.checkedKeys[this.state.fieldData[f]]
                        : false
                    }
                    selectedValue={this.state.selectedFields[this.state.fieldData[f]]
                        ? this.state.selectedFields[this.state.fieldData[f]]
                        : undefined
                    }
                    usedValues={Object.keys(this.state.selectedFields).map((e) => this.state.selectedFields[e])}
                    structure={this.state.structure}
                    korrigieren={this.state.korrigieren}
                    ubernehmen={this.state.ubergenommen}
                />
            </div>
        );
    }

    private getMappingValues() {
        return (
            <ImportMappingValues
                modul={this.props.modul}
                structure={this.state.structure}
                fieldData={this.state.fieldData}
                selectedFields={this.state.selectedFields}
                selectedValues={this.state.selectedValues}
                usedValues={Object.keys(this.state.selectedFields).map((field: string) => this.state.selectedFields[field])}
                onChange={this.onChange}
                onValueChange={this.onValueChange}
            />
        );
    }
   /*
    Object.keys(this.state.selectedFields).length !== 0
        ? this.checkUndefined(this.state.selectedFields, this.state.fieldData[f], f)
        : {}
    */
   /*
    private newSelectedFields() {
        const fields = this.state.fields;
        const newSelectedFieldsArray: Array<any> = [];
        const structure = this.state.structure.ATTS;
        const selectedFields = this.state.selectedFields;
        const fieldData = this.state.fieldData;
        const newSelectedFields: any = {};

        for ( let i = 0; i < fields.length; i++) {
            if (selectedFields[fieldData[i]]) {
                newSelectedFields[fieldData[i]] = selectedFields[fieldData[i]];
            } else {
                newSelectedFields[fieldData[i]] = structure[i].KEY;
            }
        }
        this.setState({ changed: true });
        return newSelectedFields;
    }
    */

    private isRequired(att: any) {
        return typeof att.REQUIRED !== 'undefined' && (+att.REQUIRED === 1 || att.REQUIRED.toString().toLowerCase() === 'yes');
    }

    private isKey(att: any) {
        return typeof att.REQUIRED !== 'undefined' && (att.REQUIRED.toString().toLowerCase() === 'key');
    }

    private onFinish() {
        const data = this.props.data;
        data.selectedFields = this.state.selectedFields;
        data.selectedValues = this.state.selectedValues;
        data.checkedKeys = this.state.checkedKeys;
        data.checkDaten = true;
        this.props.onDataChange(data);
        this.props.onDone();
    }

    private hasAllRequired(fields: any) {
        return Object.keys(this.state.requiredFields || {}).every((field: string) => {
            return Object.values(fields || {}).indexOf(field) !== -1
        });
    }

    private hasAllKeys(fields: any) {
        console.log('hasAllKeys: ',this.state.keyFields, fields);
        return Object.keys(this.state.keyFields || {}).every((field: string) => {
            return Object.values(fields || {}).indexOf(field) !== -1
        });
    }

    private hasSelectedField() {
        let found = false;
        this.state.fields.forEach((f) => {
            if (this.state.selectedFields[this.state.fieldData[f]] && this.state.selectedFields[this.state.fieldData[f]] !== 'UNUSED') {
                found = true;
            }
        });
        return found;
    }
    /*
    private setCorrect() {
        this.setState({ selectedFields: {}, korrigieren: true, structureProblem: false });
        this.getMappings();
    }
    */
}
